<template>
  <VWidget
    :title="$t('Subtaxonomy')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-autocomplete
        v-model="taxonomy.parent_id"
        :items="selectableParentTaxonomy"
        :label="$t('Parent taxonomy')"
        item-text="name"
        item-value="id"
        outline
        @change="updateParent"
      />
      <v-autocomplete
        v-model="taxonomy.children"
        :items="selectableChildrenTaxonomy"
        :label="$t('Children taxonomy')"
        item-text="name"
        item-value="id"
        multiple
        outline
        @change="updateChildren"
      />
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'TaxonomySingleTreeRelations',

  props: {
    taxonomy: {
      type: Object,
      required: true
    },
    taxonomyItems: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      selectableChildrenTaxonomy: [],
      selectableParentTaxonomy: []
    }
  },

  async created () {
    await this.updateParent(this.taxonomy.parent_id)
    await this.updateChildren(this.taxonomy.children_ids)
  },

  methods: {
    updateParent (val) {
      this.selectableChildrenTaxonomy = this.taxonomyItems.filter(item => {
        return item.id !== val && item.id !== this.taxonomy.id
      })

      if (!val) {
        this.taxonomy.parent_id = null
      }
    },

    updateChildren (val) {
      if (!val) {
        this.selectableParentTaxonomy = [{ id: 0, name: 'No parent' }, ...this.taxonomyItems]
        return
      }

      const filtered = this.taxonomyItems.filter(item => {
        return !val.includes(item.id) && item.id !== this.taxonomy.id
      })

      this.selectableParentTaxonomy = [{ id: 0, name: 'No parent' }, ...filtered]
    }
  }
}
</script>
